export default {
  bgColor: '#F5F7FA',

  primary: {
    light: '#4DB0F4',
    main: '#0291EF',
    dark: '#0270BA',
  },

  secondary: {
    light: '#33E0D0',
    main: '#02D3BF',
    dark: '#01A899',
  },

  auxiliar: {
    info: '#0291EF',
    success: '#02D3BF',
    warning: '#FFC107',
    danger: '#E53935',
    // Talent dashboard vurgu renkleri (havuz/kritik) — mevcut info/success/warning/danger
    // değerlerinin hiçbiriyle eşleşmiyor, o yüzden ayrı token (task-10-11 İş 2).
    purple: '#8B5CF6',
    critical: '#EF4444',
    // Yumuşak zemin/metin tonları — anket soru kartı (öne çıkar yıldızı, sil düğmesi üzerine gelme).
    dangerSoft: '#FEF2F2',
    warningSoft: '#FEF3C7',
    warningText: '#B45309',
  },

  // Kart yüzeyi/kenarlığı — yeni token grubu (task-10-11 İş 2). DİKKAT: `border.light` /
  // `border.main` isimlerini KULLANMA — bu isimler zaten birkaç sayfada
  // `theme.colors.border?.light || '#E8ECF0'` gibi savunmacı fallback'lerle referans alınıyor
  // (ör. AnnouncementDetailsPage, EmployeeReportsPage, PuantajPage); o key'leri doldurmak o
  // sayfaların render edilen rengini SESSİZCE değiştirir. `surface` boş bir isim alanı.
  surface: {
    card: '#fff',
    border: '#EDF1F4',
    borderHover: '#E2E8F0',
  },

  // rgba(0, 66, 66, alpha) gölge tonu — repo genelinde 100+ dosyada literal olarak kullanılıyor;
  // burada yalnız YENİ sayfalarda (talent-dashboard, talent-upsell) tüketilen taban RGB üçlüsü.
  shadow: {
    rgb: '0, 66, 66',
  },

  text: {
    primary: '#004242',
    // İkincil/soluk metin (kart etiketleri, açıklama metni) — task-10-11 İş 2.
    muted: '#6B7280',
    dark: {
      little: '#667',
      medium: '#004242',
      very: '#002121',
    },
    light: {
      little: '#aaa',
      medium: '#ccc',
      very: '#fff',
    },
  },

  // Takvimim (spec 2026-10-30 §3.3) — üç katman: resmî tatil kırmızı, onaylı izin mavi (marka), bekleyen izin sarı +
  // kesik turuncu kenar. "soft" = izin aralığında ama izinden düşmeyen gün (açık ton). Mobil theme/colors.js'te aynı grup.
  calendar: {
    holidayBg: '#FDE7E5',
    holidayText: '#D92D20',
    holidayHalfFill: '#FBCFCA',
    holidayHalfBorder: '#F4A9A2',
    holidaySoftBg: '#FEF4F3',
    approved: '#0291EF',
    approvedSoft: '#D3EBFC',
    approvedSoftText: '#0270BA',
    approvedTagBg: '#E6F4FE',
    waitingBg: '#FEF3C7',
    waitingSoftBg: '#FFFAEB',
    waitingBorder: '#F59E0B',
    waitingText: '#B45309',
    stepDone: '#02B5A4',
    currentMonthBg: '#F5FAFF',
    currentMonthBorder: '#DCEEFC',
    faint: '#A0A8B4',
    weekendFaint: '#C3CAD2',
    chipOff: '#CBD2D9',
    chipHoverBorder: '#D5DEE6',
    chipHoverBg: '#FAFBFC',
    cellHover: 'rgba(0, 66, 66, 0.06)',
    cellPicked: 'rgba(0, 66, 66, 0.10)',
    todayPulse: 'rgba(2, 145, 239, 0.18)',
    headerActiveBg: 'rgba(2, 145, 239, 0.10)',
    headerHoverBg: 'rgba(2, 145, 239, 0.08)',
  },

  // Organizasyon şeması (spec 2026-10-24 §5.4): kartta renk YALNIZ departmanı anlatır. Renk departmentId'den
  // kararlı karmayla seçilir (orgChartModel.departmentColor); departmansız pozisyon nötr gri. İlk renk Flexbee mavisi.
  // Bağ çizgisi: vurgusuz `line`, kökten seçili kişiye giden yol primary.main.
  orgChart: {
    departmentPalette: ['#0291EF', '#8B5CF6', '#F59E0B', '#EC4899', '#10B981', '#06B6D4', '#EF4444', '#6366F1', '#84CC16', '#F97316'],
    neutral: '#A0A8B4',
    line: '#C9D2DC',
    canvas: '#F5F7FA',
    teamBox: 'rgba(226, 232, 240, 0.45)',
    teamBoxBorder: '#E2E8F0',
  },

  // Anket sonuç raporu (spec 2026-10-15; 2026-10-16 U2) — Flexbee mavisi / turuncu dil. Web bölümleri ve tarayıcı PDF'i
  // (react-pdf, tema bağlamı yok) AYNI değerleri kullanır; tek kaynak burası (reportPalette.js yeniden dışa aktarır).
  // brand = primary.main (üst bant, başlık vurgusu); brandDark = primary.dark (beyaz küçük yazının okunması gereken zemin).
  report: {
    brand: '#0291EF',
    brandDark: '#0270BA',
    accent: '#E8A33D',
    blue: '#2F6DB5',
    blueLight: '#A9C6E8',
    orange: '#E0812C',
    orangeLight: '#F3B27A',
    gray: '#C9CFD8',
    grayLight: '#E6E9EE',
    paper: '#FFFFFF',
    panel: '#F3F6FA',
    noteBg: '#FFF6EA',
    noteBorder: '#F6D7AE',
    noteTitle: '#B85E12',
    text: '#1F2A37',
    muted: '#6B7280',
    strongBg: '#EAF1FA',
    priorityBg: '#FCEFE3',
  },
};
